/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Prepare_BodyInputs */

const en_how_we_work_prepare_body = /** @type {(inputs: How_We_Work_Prepare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A real example tells us more than a long technical brief. Bring these three things to the first conversation.`)
};

const lv_how_we_work_prepare_body = /** @type {(inputs: How_We_Work_Prepare_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reāls piemērs pastāsta vairāk nekā garš tehnisks apraksts. Atnesiet uz pirmo sarunu šīs trīs lietas.`)
};

/**
* | output |
* | --- |
* | "A real example tells us more than a long technical brief. Bring these three things to the first conversation." |
*
* @param {How_We_Work_Prepare_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_prepare_body = /** @type {((inputs?: How_We_Work_Prepare_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Prepare_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_prepare_body(inputs)
	return en_how_we_work_prepare_body(inputs)
});